import React, {useEffect, useState} from "react";
import Question from "./question";
import Results from "./results";

export default function Quiz() {
  const [currentQuestionId, setCurrentQuestionId] = useState(1);
  const [totalQuestions, setTotalQuestions] = useState(undefined);
  const [currentAnswers, setCurrentAnswers] = useState({});
  const [correctAnswers, setCorrectAnswers] = useState({});
  const [quizFinished, setQuizFinished] = useState(false);

  useEffect( () => {
    fetch(`/quiz-klimatyczny/questions/${currentQuestionId}.json`)
      .then((response) => response.json())
      .then((question) => setTotalQuestions(question.totalQuestions));
  },[])

  return quizFinished ? (
    <Results currentAnswers={currentAnswers}
             correctAnswers={correctAnswers}
             totalQuestions={totalQuestions}/>) :
    (
      <Question questionId={currentQuestionId}
              totalQuestions={totalQuestions}
              prevHandler={() => setCurrentQuestionId(currentQuestionId-1)}
              nextHandler={() => setCurrentQuestionId(currentQuestionId+1)}
              setCurrentQuestionId={setCurrentQuestionId}
              currentAnswers={currentAnswers}
              setCurrentAnswers={setCurrentAnswers}
              correctAnswers={correctAnswers}
              setCorrectAnswers={setCorrectAnswers}
              setQuizFinished={(quizFinished) => {
                    if (quizFinished) window.scrollTo(0,0);
                    setQuizFinished(quizFinished);
              }}/>
  );
}